var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunningIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96323 1.99902H10.0364C10.5216 1.99902 10.9141 2.48426 10.9141 2.87677V5.74324C10.9141 6.22847 10.521 6.62098 10.0364 6.62098H9.96323C9.47799 6.62098 9.08548 6.13575 9.08548 5.74324V2.87677C9.08548 2.39153 9.47864 1.99902 9.96323 1.99902Z",
    fill: "#25C277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96323 13.3771H10.0364C10.5216 13.3771 10.9141 13.8623 10.9141 14.2548V17.1213C10.9141 17.6065 10.521 17.999 10.0364 17.999H9.96323C9.47799 17.999 9.08548 17.5138 9.08548 17.1213V14.2548C9.08548 13.7696 9.47864 13.3771 9.96323 13.3771Z",
    fill: "#25C277"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 10.0359V9.96274C1.99951 9.4775 2.48475 9.08499 2.87726 9.08499H5.74372C6.22896 9.08499 6.62147 9.47816 6.62147 9.96274V10.0359C6.62147 10.5211 6.13624 10.9136 5.74372 10.9136H2.87726C2.39202 10.9136 1.99951 10.5205 1.99951 10.0359Z",
    fill: "#25C277"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3776 10.0359V9.96274C13.3776 9.4775 13.8628 9.08499 14.2553 9.08499H17.1218C17.607 9.08499 17.9995 9.47816 17.9995 9.96274V10.0359C17.9995 10.5211 17.5143 10.9136 17.1218 10.9136H14.2553C13.7701 10.9136 13.3776 10.5205 13.3776 10.0359Z",
    fill: "#25C277"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31666 4.36831L4.36825 4.31672C4.71112 3.97384 5.3322 4.0385 5.60977 4.31672L7.63628 6.34322C7.97915 6.6861 7.97915 7.24187 7.63628 7.58474L7.58468 7.63633C7.24181 7.97921 6.62073 7.91455 6.34316 7.63633L4.31666 5.60983C3.97379 5.26696 3.97379 4.71118 4.31666 4.36831Z",
    fill: "#25C277"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3627 12.4137L12.4143 12.3621C12.7572 12.0192 13.3782 12.0839 13.6558 12.3621L15.6823 14.3886C16.0252 14.7315 16.0252 15.2873 15.6823 15.6301L15.6307 15.6817C15.2878 16.0246 14.6668 15.9599 14.3892 15.6817L12.3627 13.6552C12.0198 13.3123 12.0198 12.7566 12.3627 12.4137Z",
    fill: "#25C277"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36885 15.6824L4.31726 15.6308C3.97438 15.288 4.03904 14.6669 4.31726 14.3893L6.34376 12.3628C6.68664 12.0199 7.24241 12.0199 7.58528 12.3628L7.63687 12.4144C7.97975 12.7573 7.91509 13.3783 7.63687 13.6559L5.61037 15.6824C5.2675 16.0253 4.71172 16.0253 4.36885 15.6824Z",
    fill: "#25C277"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4142 7.63644L12.3626 7.58485C12.0198 7.24197 12.0844 6.6209 12.3626 6.34333L14.3891 4.31682C14.732 3.97395 15.2878 3.97395 15.6307 4.31682L15.6823 4.36842C16.0251 4.71129 15.9605 5.33237 15.6823 5.60993L13.6557 7.63644C13.3129 7.97931 12.7571 7.97931 12.4142 7.63644Z",
    fill: "#25C277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningIconActive);
export default __webpack_public_path__ + "static/media/running-icon-active.798333ebf64cddc7470f2b7f21ec7827.svg";
export { ForwardRef as ReactComponent };